import { useState, useRef, useEffect } from 'react';
import debounce from 'lodash/debounce';

export default function useStateWithDebounce(
  initialState,
  timeout,
  options = {},
) {
  const [state, setState] = useState(initialState);
  const debouncedSetState = useRef(debounce(setState, timeout, options));

  useEffect(() => () => debouncedSetState.current.cancel(), []);

  return [state, (nextState) => debouncedSetState.current(nextState)];
}
